import React from 'react';
import { Mic } from 'react-bootstrap-icons';
import ChatPreview from './ChatPreview';

export default function Hero({ onSignIn }) {
  const scrollTo = (selector) => {
    document.querySelector(selector)?.scrollIntoView({ behavior: 'smooth' });
  };
  const scrollToCapabilities = () => scrollTo('#capabilities');
  const scrollToLive = () => scrollTo('#live');

  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-brand-navy-50 via-white to-white">
      <div
        className="pointer-events-none absolute -left-24 top-10 h-64 w-64 rounded-full bg-brand-sky/20 blur-3xl"
        aria-hidden
      />
      <div
        className="pointer-events-none absolute right-0 top-32 h-72 w-72 rounded-full bg-brand-amber/15 blur-3xl"
        aria-hidden
      />

      <div className="relative mx-auto grid max-w-landing items-center gap-10 px-4 pb-10 pt-12 sm:px-6 lg:grid-cols-2 lg:gap-16 lg:px-8 lg:pb-12 lg:pt-16">
        <div>
          <div className="mb-3 flex flex-wrap items-center gap-2">
            <p className="m-0 text-sm font-semibold uppercase tracking-wide text-brand-navy">
              AI Teaching Assistant
            </p>
            <button
              type="button"
              onClick={scrollToLive}
              className="inline-flex items-center gap-1.5 rounded-pill bg-brand-navy px-2.5 py-1 text-[11px] font-bold uppercase tracking-wide text-white transition hover:bg-brand-navy-800"
            >
              <Mic size={11} />
              New · Live voice
            </button>
          </div>
          <h1 className="font-display text-4xl font-extrabold tracking-tight text-brand-ink sm:text-5xl lg:text-[3.25rem]">
            Your AI study buddy for school work
          </h1>
          <p className="mt-4 max-w-xl text-base leading-relaxed text-brand-muted sm:text-lg">
            Type it, upload a photo or PDF, or just talk out loud — SchoolCracked guides
            you with hints and questions so you figure it out yourself and it sticks.
          </p>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            <button
              type="button"
              onClick={onSignIn}
              className="rounded-pill bg-brand-navy px-7 py-3 text-base font-semibold text-white shadow-brand-md transition hover:bg-brand-navy-800"
            >
              Start learning
            </button>
            <button
              type="button"
              onClick={scrollToCapabilities}
              className="rounded-pill border border-brand-navy/20 bg-white px-6 py-3 text-base font-semibold text-brand-navy transition hover:border-brand-navy/40 hover:bg-brand-navy-50"
            >
              See what it can do
            </button>
          </div>
          <p className="mt-4 text-sm text-brand-muted">Made for Cogniz Tech students.</p>
        </div>

        <ChatPreview />
      </div>
    </section>
  );
}
